var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5476 12.6924V9.24098C15.5476 6.13405 13.0303 3.6167 9.92333 3.6167H9.17475C6.06782 3.6167 3.55047 6.13405 3.55047 9.24098V12.6924C2.09968 12.9508 1 14.2161 1 15.7331V16.1504C1 17.8596 2.38454 19.2441 4.09369 19.2441H15.0044C16.7135 19.2441 18.0981 17.8596 18.0981 16.1504V15.7331C18.0981 14.2094 16.9984 12.9441 15.5476 12.6924Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94824 3.74921V2.59653C7.94824 1.71546 8.6637 1 9.54477 1C10.4258 1 11.1413 1.71546 11.1413 2.59653V3.74921",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1354 19.251V20.4037C11.1354 21.2847 10.42 22.0002 9.53891 22.0002C8.65784 22.0002 7.94238 21.2847 7.94238 20.4037V19.251",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmSimple);
export default __webpack_public_path__ + "static/media/AlarmSimple.da24514df911818417842b3ae6e33ef2.svg";
export { ForwardRef as ReactComponent };